import moment from "moment";

export const firstWordCapital = (str) => {
  if (typeof str !== "string" || !str.trim()) {
    return str; // Return as is if it's not a valid string
  }

  const [firstWord, ...rest] = str.trim().split(" ");
  return `${firstWord.charAt(0).toUpperCase() + firstWord.slice(1)} ${rest.join(
    " "
  )}`;
};

// Utility function
export const getValueOrFallback = (value) => {
  return value ?? "---";
};

export const capitalizeAndJoin = (words, separator = ",") => {
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(separator);
};

export function getAgeInWords(isoString) {
  const date = moment(isoString);
  const now = moment();
  const months = now.diff(date, "months");
  const years = now.diff(date, "years");
  const remainingMonths = months % 12;

  if (months < 1) {
    return `${now.diff(date, "days")} days old`;
  } else if (months < 12) {
    return `${months} ${months === 1 ? "month" : "months"} old`;
  } else {
    return remainingMonths === 0
      ? `${years} ${years === 1 ? "year" : "years"} old`
      : `${years} ${years === 1 ? "year" : "years"} and ${remainingMonths} ${remainingMonths === 1 ? "month" : "months"} old`;
  }
}

export function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  let result = '';
  if (h > 0) result += `${h}h `;
  if (m > 0) result += `${m}m `;
  if (s > 0 || result === '') result += `${s}s`;

  return result.trim();
}

export function formatTimeInDays(seconds) {
  const d = Math.floor(seconds / 86400); // 1 day = 86400 seconds
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  let result = '';
  if (d > 0) result += `${d} days `;
  if (h > 0) result += `${h} hours `;
  if (m > 0) result += `${m} min `;
  if (s > 0 || result === '') result += `${s} sec`;

  return result.trim();
}

export function formatRelativeDate(dateString) {
  // Parse the input date (expected format: DD-MM-YYYY)
  const [day, month, year] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day); // Month is 0-based in JS

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date.getTime() === today.getTime()) {
    return "Today";
  } else if (date.getTime() === yesterday.getTime()) {
    return "Yesterday";
  } else {
    return date.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  }
}

